<template>
  <div class="Header">
    <div class="container-fluid">
      <div class="row">
        <!-- leftside -->
        <div class="col-lg-3">
          <a class="deunderline" href="#/">
            <div class="logo-wrapper">
              <div class="logo-con">
                <div class="white-box">
                  <img src="../assets/logo.gif" id="logo" alt="logo" />
                </div>
                <div class="white-box">
                  <div class="rent-boat">RENT BOAT</div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <!-- rightside -->
        <div class="col-lg-9 title-text">
          <strong>
            <a href="#/" class="logo-link">
              <div>Chicago River Canoe &amp; Kayak</div>
            </a>
          </strong>
          <div class="established">Since 2001</div>
        </div>
      </div>
    </div>

    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-nav>
          <b-navbar-toggle target="navbar-wrapper" class="toggle-button">
            <button class="btn btn-primary">
              <i class="fas fa-bars"></i>
              Welcome
            </button>
          </b-navbar-toggle>

          <b-collapse is-nav id="navbar-wrapper">
            <b-nav-item href="#/">Home</b-nav-item>

            <!-- Navbar dropdowns -->
            <b-nav-item-dropdown text="Locations">
              <b-dropdown-item to="Busse">
                Busse Reservoir, Elk Grove Village <br />
                <span class="nav-subtext">
                  <strong>Opens: 4/18, Hours: 9:00 a.m. until last rental, 6:00 p.m. Weekends Only until Memorial Day</strong>           
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="ClarkPark">
                Clark Park Boathouse, Chicago <br />
                <span class="nav-subtext">
                  <strong>Opens: 4/25, Hours: 9:00 a.m. until last rental, 6:00 p.m. Weekends Only until Memorial Day</strong> 
                </span>
              
              </b-dropdown-item>
              <b-dropdown-item to="Skokie"
                >Skokie Lagoons, Winnetka <br />
                <span class="nav-subtext">
                 <strong>Opens: 4/25, Hours: 9:00 a.m. until last rental, 6:00 p.m. Weekends Only until Memorial Day</strong>
                </span>
              </b-dropdown-item>

              <b-dropdown-item to="LakeTampier"
                >Lake Tampier, Orland Park <br />
                <span class="nav-subtext">
                 <strong>Opens: 4/18, Hours: 9:00 a.m. until last rental, 6:00 p.m. Weekends Only until Memorial Day</strong> 
                  <br />
                </span>
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item to="Pricing">Pricing</b-nav-item>
            <b-nav-item to="Events">Events</b-nav-item>
            <b-nav-item to="Groups">Groups</b-nav-item>
            <b-nav-item to="FAQ">FAQ</b-nav-item>

            <b-nav-item-dropdown text="Other" right>
              <b-dropdown-item to="Employment">Employment</b-dropdown-item>
              <b-dropdown-item to="Waiver">Parental Waiver</b-dropdown-item>
              <b-dropdown-item to="Gift">Gift Certificates</b-dropdown-item>
              <b-dropdown-item to="Used">Used Boats</b-dropdown-item>
              <b-dropdown-item to="Links">Links</b-dropdown-item>
              <!-- <b-dropdown-item to="Event">The Event</b-dropdown-item> -->
            </b-nav-item-dropdown>
            <b-nav-item to="Contact">Contact</b-nav-item>
            <!-- <b-nav-item to="Boats">Boats</b-nav-item> -->

          </b-collapse>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red {
  color: red;
}
.logo-con {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.established {
  text-align: center;
  font-size: 20px;
}
.Header {
  border-bottom: 5px solid #c0504d;
}
.Header >>> .navbar-dark .navbar-nav .nav-link {
  font-size: 23px;
  color: white;
  padding-bottom: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.Header >>> .bg-dark {
  background-color: transparent !important;
}
.Header >>> .navbar-expand {
  padding-right: 100px;
  justify-content: flex-end;
}
.logo-wrapper {
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.logo-link:hover {
  text-decoration: none;
  color: #c0504d;
}
.logo-link {
  color: white !important;
  line-height: 40px;
  font-size: 37px;
  text-align: center;
}
.logo-blk {
  color: black;
}
.rent-boat {
  color: red;
  font-size: 30px;
  line-height: 40px;
  font-weight: 600;
  border: 6px solid red;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  padding-right: 10px;
}
#logo {
  height: 100px;
  padding-left: 0px;
}
.title-text {
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 34px;
  padding-left: 40px;
}
.Header >>> .dropdown-item:hover {
  background-color: #76923d;
}
.Header >>> .toggle-button {
  width: 200px;
  border: none;
}
.white-box:nth-child(2) {
  margin-left: 20px;
}
@media screen and (max-width: 1025px) {
  .white-box:nth-child(2) {
    margin-left: 20px;
  }
}
@media screen and (max-width: 768px) {
  .title-text {
    display: none;
  }
  .white-box:nth-child(2) {
    margin-left: 80px;
  }
}

@media screen and (max-width: 991px) {
  .logo-con {
    justify-content: center;
  }
}

.router-link-active {
  background-color: rgba(255, 50, 50, 0.5);
  border-radius: 8px 8px 0px 0px;
}
.white-box {
  background: white;
  padding: 10px;
  border: 1px solid black;
}
.deunderline:hover {
  text-decoration: none;
}
.nav-subtext {
  color: red;
  font-size: 0.75rem;
}
</style>
